function MyUpdateFlagSetter() {

  this.setFlag = function (data, updatingDatasetId, filterFn) {
    data.isMyUpdate = true;
    if (!data.hasOwnProperty(updatingDatasetId)) {
      data.isMyUpdate = false;
      return false;
    }

    try {
      if (filterFn && filterFn(data) === false) {
        data.isMyUpdate = false;
        return false;
      }
    } catch (e) {
      return false;
    }

    return true;
  }
}

module.exports = new MyUpdateFlagSetter();


// WEBPACK FOOTER //
// ./src/components/dashboard/widgets/my-update-flag-setter.js